module.exports = __webpack_public_path__ + "static/media/mail-icon.6a59d087.svg";